import { Company } from './company';
import { Token } from './token';
import Role from './enums/role';
import { SalesforceSettings } from './salesforceSettings';
import { EmailSettings } from './emailSettings';
import { OtherSettings } from './otherSettings';
import { HubspotSettings } from './hubspotSettings';
import { UserPreferences } from './userPreferences';
import { PipedriveSettings } from './pipedriveSettings';
import { AttioSettings } from './attioSettings';
import { ZohoSettings } from './zohoSettings';
import { DynamicsSettings } from './dynamicsSettings';
import { AircallSettings } from './aircallSettings';
import { IntegrationsOnboarding } from './DTO/integrationsOnboarding';
import IntegrationType from './enums/integrationType';
import { FeaturesOnboarding } from './DTO/featuresOnboarding';
import SubscriptionPlanType from './enums/subscriptionPlanType';
import UserStatus from './enums/userStatus';
import CallIntegrationType from './enums/callIntegrationType';

export interface User {
  id: number;
  subscriptionId: number;
  email: string;
  firstName: string | null;
  lastName: string | null;
  company: Company | null;
  userRoles: Role[];
  token: Token;
  salesforceSettings: SalesforceSettings | null;
  hubspotSettings: HubspotSettings | null;
  pipedriveSettings: PipedriveSettings | null;
  attioSettings: AttioSettings | null;
  zohoSettings?: ZohoSettings | null;
  dynamicsSettings?: DynamicsSettings | null;
  emailSettings: EmailSettings | null;
  aircallSettings: AircallSettings | null;
  userPreferences: UserPreferences;
  integrationsOnboarding?: IntegrationsOnboarding | null;

  teams?: {
    id: number;
    name: string;
  }[];

  featuresOnboarding: FeaturesOnboarding | null;
  // [WARNING] Always use user.company.integrationType to do checks of integration type of the subscription, and use user.integrationType only in specific cases related to the user's first integration.
  // ONLY after the first integration is completed, in this is going to be set the integration type value
  integrationType?: IntegrationType | null;

  otherSettings: OtherSettings | null;
  active: boolean | null;
  status: UserStatus | null;
  candidate?: boolean;
  lastLogin?: Date | null;
  subscriptionType?: SubscriptionPlanType | null;
  callIntegrationType: CallIntegrationType | null;
}

export function getFullName(user: {
  firstName?: string | null;
  lastName?: string | null;
}): string {
  return `${user.firstName || ''} ${user.lastName || ''}`;
}
